import { c as _c } from "react/compiler-runtime";
import { Icon } from "@repo/ui/icon";
import { ListingCardShell, ListingCardImage, ListingCardContent } from "../parts";
import type { VisualType } from "@/lib/types";
export function HotelCard(t0) {
  const $ = _c(22);
  const {
    visual,
    title,
    href,
    rating,
    district,
    className,
    imageSizes,
    imageCropAspect
  } = t0;
  let t1;
  if ($[0] !== imageCropAspect || $[1] !== imageSizes || $[2] !== visual) {
    t1 = <ListingCardImage visual={visual} sizes={imageSizes} cropAspect={imageCropAspect} />;
    $[0] = imageCropAspect;
    $[1] = imageSizes;
    $[2] = visual;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== rating) {
    t2 = <span className="typography-component-md-medium text-text-primary">{rating}</span>;
    $[4] = rating;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Icon name="star" filled={true} size="md" className="text-text-primary" decorative={true} />;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2) {
    t4 = <div className="flex items-center gap-1">{t2}{t3}</div>;
    $[7] = t2;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== title) {
    t5 = <p className="w-full typography-component-sm-medium text-text-primary desktop:typography-component-md-medium">{title}</p>;
    $[9] = title;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== district) {
    t6 = district && <p className="typography-component-xs-regular text-text-secondary desktop:typography-component-sm-regular">{district}</p>;
    $[11] = district;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t4 || $[14] !== t5 || $[15] !== t6) {
    t7 = <ListingCardContent gapClass="gap-2">{t4}{t5}{t6}</ListingCardContent>;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== className || $[18] !== href || $[19] !== t1 || $[20] !== t7) {
    t8 = <ListingCardShell href={href} gapClass="gap-3 desktop:gap-4" className={className}>{t1}{t7}</ListingCardShell>;
    $[17] = className;
    $[18] = href;
    $[19] = t1;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
}